import { forwardRef } from "react";
import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";

const TextArea = forwardRef(
  (
    {
      name,
      placeholder,
      rows = 3,
      style,
      autoComplete,
      autoCorrect,
      onChange,
      required,
      containerStyle,
      contentStyle,
      errorMessage,
      value,
      defaultValue,
    },
    ref
  ) => {
    return (
      <div className={`d-flex flex-column ${containerStyle}`}>
        <textarea
          defaultValue={defaultValue}
          ref={ref}
          name={name}
          className={`textArea ${contentStyle}`}
          placeholder={placeholder}
          rows={rows}
          dirname={getDir(getCurrentLangFromRedux())}
          style={{ resize: "none", ...style }}
          autoComplete={autoComplete}
          autoCorrect={autoCorrect}
          onChange={onChange}
          required={required ?? false}
          value={value}
        ></textarea>
        {errorMessage ? (
          <div style={{ fontSize: 14, color: "red" }}>{errorMessage}</div>
        ) : null}
      </div>
    );
  }
);

export default TextArea;
